import { Link, useLocation } from 'react-router-dom';
import { Hammer, FolderOpen, Home } from 'lucide-react';

export default function Header() {
  const location = useLocation();
  const isBuilder = location.pathname.startsWith('/builder');

  return (
    <header className="glass-header sticky top-0 z-50 h-16 flex items-center px-6" data-testid="app-header">
      <Link to="/" className="flex items-center gap-2.5 mr-8" data-testid="header-logo">
        <div className="w-8 h-8 bg-[#C25934] rounded-sm flex items-center justify-center">
          <Hammer className="w-4 h-4 text-white" />
        </div>
        <span className="text-lg font-bold tracking-tight text-[#1C1C1C]" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
          MebelCraft
        </span>
      </Link>

      <nav className="flex items-center gap-1" data-testid="header-nav">
        <Link
          to="/"
          data-testid="nav-home"
          className={`px-3 py-2 rounded-sm text-sm font-medium transition-colors flex items-center gap-1.5 ${
            location.pathname === '/'
              ? 'bg-[#C25934]/10 text-[#C25934]'
              : 'text-[#5C5C5C] hover:text-[#1C1C1C] hover:bg-black/5'
          }`}
        >
          <Home className="w-4 h-4" />
          Каталог
        </Link>
        <Link
          to="/builder"
          data-testid="nav-builder"
          className={`px-3 py-2 rounded-sm text-sm font-medium transition-colors flex items-center gap-1.5 ${
            isBuilder
              ? 'bg-[#C25934]/10 text-[#C25934]'
              : 'text-[#5C5C5C] hover:text-[#1C1C1C] hover:bg-black/5'
          }`}
        >
          <Hammer className="w-4 h-4" />
          Конструктор
        </Link>
        <Link
          to="/saved"
          data-testid="nav-saved"
          className={`px-3 py-2 rounded-sm text-sm font-medium transition-colors flex items-center gap-1.5 ${
            location.pathname === '/saved'
              ? 'bg-[#C25934]/10 text-[#C25934]'
              : 'text-[#5C5C5C] hover:text-[#1C1C1C] hover:bg-black/5'
          }`}
        >
          <FolderOpen className="w-4 h-4" />
          Проекты
        </Link>
      </nav>
    </header>
  );
}
